/*!
* name ZJX 个人中心 - 盒子
* Copyright 2018-2019
*/
<template>
  <div class="personal_center_content clearfix">
    <div class="personal_center_crumbs">乐画 > 个人中心</div>
    <div class="personal_center_menu_left">
      <ul class="personal_center_menu_left_ul">
        <li
          v-for="(item,index) in isTeacherStudent"
          :key="index"
          @click="switchMenu(item)"
          :class="curId == item.id ? cur : ''"
        >{{item.menuName}}
        </li>
      </ul>
    </div>
    <div class="personal_center_menu_right">
      <!-- 当前个人中心需要使用的主体盒子 -->
      <!-- <router-view/> -->
      <component :is="tabBox"/>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex' // 引入全局vuex
import cacheUtils from '@/common/cacheUtils' //调用缓存
import personalcenters from '@/views/personalcenter/personalinformation' //个人信息
import samplereels from '@/views/personalcenter/samplereels' //作品集
import auditworksresources from '@/views/personalcenter/auditworksresources' //作品资源审核
import upload from '@/views/personalcenter/upload' //上传
import teachingresources from '@/views/personalcenter/teachingresources' //教学资源
import apiInterface from '@/api/index' //接口
export default {
  data () {
    return {
      teacherMenuList: [
        {
          id: 1,
          path: 'personalcenters',
          menuName: '个人信息'
        },
        {
          id: 2,
          path: 'samplereels',
          menuName: '作品集'
        },
        {
          id: 3,
          path: 'teachingresources',
          menuName: '教学资源'
        },
        {
          id: 4,
          path: 'upload',
          menuName: '上传'
        },
        {
          id: 5,
          path: 'auditworksresources',
          menuName: '作品资源审核'
        }
      ], // 老师菜单集合
      studentMenuList: [
        {
          id: 1,
          path: 'personalcenters',
          menuName: '个人信息'
        },
        {
          id: 2,
          path: 'samplereels',
          menuName: '我的作品'
        },
        {
          id: 3,
          path: 'teachingresources',
          menuName: '我的下载'
        },
        {
          id: 4,
          path: 'upload',
          menuName: '上传'
        },
      ], // 学生菜单集合
      isTeacherStudent: [], // 从登陆进来判断使用老师导航还是学生导航
      cur: 'tagCur', // 附加样式
      curId: 1, // 默认被选中的ID
      tabBox: 'personalcenters',
      isWXLogin: false,
      isFirstEdit: false
    }
  },
  computed: {
    ...mapGetters(['navstate', 'personalcenter'])
  },
  mounted () {},
  components: {
    personalcenters,
    samplereels,
    auditworksresources,
    upload,
    teachingresources
  },
  created () {
    // 判断如果等于1就显示老师导航如果是2就是学生导航
    if (cacheUtils.sessionStorage('status').get('zjx') == 1) {
      this.isTeacherStudent = this.teacherMenuList
    } else {
      this.isTeacherStudent = this.studentMenuList
    }
    // 判断是否是微信登录
    if (window.location.href.indexOf('wechat-feedback') !== -1) {
      this.isWXLogin = true
    }
    this.whetherLogin() // 判断下是否登录
    this.accessPersonalInformation()
  },
  methods: {
    ...mapMutations({
      navState: 'SET_NAVSTATE',
      personalCenter: 'SET_PERSONALCENTER'
    }),
    // 判断如果没有登录不可以跳转到个人中心
    whetherLogin () {
      if (cacheUtils.cookie.getObject('Token') == null) {
        cacheUtils.cookie.clear()
        cacheUtils.localStorage().clear()
        cacheUtils.sessionStorage().clear()
        this.$router.push({ path: '/' })
      }
    },
    // 切换变换样式
    switchMenu (item) {
      this.tabBox = item.path
      this.curId = item.id
      this.navState(item.menuName)
      if (cacheUtils.sessionStorage('status').get('zjx') == 1 || cacheUtils.sessionStorage('status').get('zjx') == 2) {
        if (item.menuName == '上传') {
          this.accessPersonalInformation2()
        }
      }
    },
    // 获取个人信息内容
    async accessPersonalInformation () {
      try {
        let pdata = await this.$xhr.get(apiInterface.userInfo, { params: {} })
        if ('teacher' in pdata.data) {
          if (pdata.data.teacher.certificate_state == 1 || pdata.data.teacher.certificate_state == 2 || pdata.data.teacher.certificate_state == 4) {
            //  this.isTeacherStudent =  this.teacherMenuList.filter(item => item.id !=5);
            this.tabBox = 'personalcenters'
            this.curId = 1
          }
          if (cacheUtils.sessionStorage('status').get('zjx') == 2) {
            this.isTeacherStudent = this.teacherMenuList.filter(item => item.id != 5)
          }
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 获取个人信息内容
    async accessPersonalInformation2 () {
      try {
        let pdata = await this.$xhr.get(apiInterface.userInfo, { params: {} })
        if ('teacher' in pdata.data) {
          if (pdata.data.teacher.certificate_state == 1 || pdata.data.teacher.certificate_state == 2 || pdata.data.teacher.certificate_state == 4) {
            //  this.isTeacherStudent =  this.teacherMenuList.filter(item => item.id !=5);
            this.tabBox = 'personalcenters'
            this.curId = 1
            this.$message.error('亲，请先认证后才能上传哦~')
          }
          if (cacheUtils.sessionStorage('status').get('zjx') == 2) {
            this.isTeacherStudent = this.teacherMenuList.filter(item => item.id != 5)
          }
        } else if ('student' in pdata.data) {
          // TODO 判断微信登录
          if (!pdata.data.student.phone) {
            this.tabBox = 'personalcenters'
            this.curId = 1
            this.$message.error('亲，请先完善个人信息才能上传哦~')
          } else {
            if (this.isWXLogin) {
              let studentData = pdata.data.student
              if (!studentData.age && !studentData.phone && !studentData.interest && !studentData.school_level && !studentData.student_number && !studentData.school_grade_class && !studentData.school.name) {
                this.$message.error('亲，请先完善个人信息才能上传哦~')
              }
            }
          }
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.personal_center_content {
  padding-bottom: 10px;
  width: 1000px;
  background: #fff;

  .personal_center_menu_left {
    width: 230px;
    float: left;
    box-sizing: border-box;
    padding-left: 10px;

    .personal_center_menu_left_ul {
      width: 200px;
      overflow: hidden;
      box-shadow: 0px 2px 5px 1px #e9e9e9;

      li {
        line-height: 50px;
        text-align: center;
        cursor: pointer;

        a {
          display: block;
          line-height: 50px;
          text-align: center;
        }
      }
    }
  }

  .personal_center_menu_right {
    width: 770px;
    float: right;
  }

  .personal_center_crumbs {
    width: 1000px;
    height: 55px;
    background: #fff;
    line-height: 55px;
    box-sizing: border-box;
    padding-left: 20px;
  }
}

.tagCur {
  background: #15c1e4;
  color: #fff;
}
</style>

